module.exports = __webpack_public_path__ + "fonts/CircularStd-Black.7f42d848.otf";